import { IconCalendarEvent, IconChecklist, IconSitemap, IconBriefcase2, IconFilter } from "@tabler/icons-react";
import imgs from "../../../../Utils/assets/img/faces/5.jpg";
import { formatDate, usePermissions } from "../../../../Utils/helpers/commonhelper";
import { GetRequest } from "../../../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Badge, Col, Dropdown, Row } from "react-bootstrap";
import { LeadsDetails } from "../../../detailPage/leads/LeadsDetails";
import { DealDetails } from "../../../deals/DealDetails";
import { useGetRequest } from "../../../../Utils/hooks/QueryHandler";
import { CreateLead } from "../../../Leads/CreateLead";
// import nodata from "../../../../Utils/assets/img/leads_no_data_found.png"
import { RightLeadDetailsPanel } from "../../../detailPage/leads/RightLeadDetailsPanel";
import { DealActivityPanel } from "../../../deals/DealDetailsComp/DealActivityPanel";
import { FollowUpPage } from "../../../PipelineComponents/FollowUpPage";
import nodata from "../../../../Utils/assets/img/leads_no_data_found_removebg.png";
import { useOutsideClickHandler } from "../../../../Utils/hooks/useOutsideClickHandler";
import { Pagination } from "../../../../pages/Pagination";
import { FilterPagination } from "../../../../pages/FIlterPagination";

export const MyFollowup = ({ searchInput = "" }) => {
    const [customer, setCustomer] = useLocalStorageState('customer');
    const customerId = customer?.customer_details?.customer_id;
    const loginUserId = customer?.customer_details?.id;
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate();
    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }
    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }
    const [myFollowUP, setMyFollowUp] = useState([]);
    const brandColor = "#7a3a5e";
    // const [openDetailsCard, setOpenDetailsCard] = useState(false)

    const [currModule, setCurrModule] = useState(null);
    const [currId, setCurrId] = useState(null)
    const [followupDeleteModal, setFollowupDeleteModal] = useState(false)
    // email state is being created in order to make sure that the meetings in the corresponding activity panel should be loaded, since it requires email in order to create meeting. So this meeting will be common for both lead and deal and by default will be null so that there are no state duplicacy or incorrect state passing down to components
    // well i need to correct myself that it won't stay null all the time. By default we are setting it to whichever the firstfollowup is in the listing. Below useeffect sets it whenever followup component loads initialy
    const [contactEmail, setContactEmail] = useState(null)
    const [refetchLeadsData, setRefetchLeadsData] = useState(false)
    // leads states
    const [leadsData, setLeadsData] = useState([])
    const [pipelines, setPipelines] = useState([])
    const [pipelineStages, setPipelineStages] = useState([])
    const [selectedPipelineId, setSelectedPipelineId] = useState(null)
    const [showCreateLead, setShowCreateLead] = useState(false)
    const [selectedStageId, setSelectedStageId] = useState(null)
    const [editLeadId, setEditLeadId] = useState(null)
    const [deleteLeadId, setDeleteLeadId] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    // for storing the pipeline data to pass down to the advance filtering component
    const [filterDropPipelineStage, setFilterDropPipelineStage] = useState([])
    // for storing the parsed shared users to pass down to the pipeline share model where i will render these users with their respective permissions corresponding to that pipeline
    const [parsedSharedUsers, setParsedSharedUsers] = useState(null)

    const [refetchDealsData, setrefetchDealsData] = useState(false)

    // for opening dropdown
    const [openFilter, setOpenFilter] = useState(false)
    const filterDropRef = useRef(null)
    const [filter, setFilter] = useState(`Due Followup`)
    const [showCustomInputs, setShowCustomInputs] = useState(false);
    const [customFrom, setCustomFrom] = useState("");
    const [customTo, setCustomTo] = useState("");

    // pagination states
    const limit = 10;
    const [offset, setOffset] = useState(0)
    const [totalFollowup, setTotalFollowup] = useState(0)
    // Calculate total pages
    const pageCount = Math.ceil(Number(totalFollowup) / 20);
    const displayStartItem = totalFollowup === 0 ? 0 : (offset * 2) + 1;
    const displayEndItem = totalFollowup === 0
        ? 0
        : Math.min((offset * 2) + (limit * 2), totalFollowup);

    useOutsideClickHandler({
        objRef: filterDropRef,
        isDropdown: openFilter,
        setDropdown: setOpenFilter
    })

    // permission setup for leads
    const permission = customer.customer_details?.permission
    // permission for lead
    const leadPermission = permission?.filter(c => c.module_name === "leads")
    // permission for lead and deal
    const dealPermission = permission?.filter(c => c.module_name === "deals")
    const user_type = Number(customer.customer_details?.user_type)
    const leadGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.delete)) : true,
    }
    const leadFollowupGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.delete)) : true,
    }
    const leadMeetingGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.delete)) : true,
    }
    const leadDocGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.delete)) : true,
    }
    const leadNoteGrant = {
        isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.delete)) : true,
    }

    const dealGrant = {
        isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.delete)) : true,
        isImport: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "import")?.is_action)) : true,
        isExport: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "export")?.is_action)) : true,
    }

    const dealFollowupGrant = {
        isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.delete)) : true,
    }

    // fetching leads data
    const {
        data: leadsApiData,
        // isLoading: isLeadsLoading,
        refetch: refetchLeads,
    } = useGetRequest(
        `lead/fetchLeads/${customerId}/${selectedPipelineId}/${loginUserId}/${customer.customer_details?.user_type}/list?module_name=&contact_id=`,
        ["fetchAllLeads", selectedPipelineId],
        headers,
        { customer, setCustomer, rf: headers.Authentication, navigate },
        {
            enabled: !!selectedPipelineId
        }
    );
    // custom hook permission for shared pipelines
    const { permissionAssigned, canEdit_canDownload } = usePermissions(customer, parsedSharedUsers, leadsApiData)

    // Fetch all pipelines for leads
    const {
        data: pipelineData,
        isLoading: isPipelineLoading,
        refetch: refetchPipeline,
    } = useGetRequest(`lead/fetchPipelines/${customerId}/leads/${loginUserId}/${customer.customer_details?.user_type}`, ["fetchLeadsPipeline"], headers, extras, {})
    // Handle pipeline data updates and set default selection
    useEffect(() => {
        if (pipelineData?.status === "success") {
            const fetchedPipelines = pipelineData.data || []
            setPipelines(fetchedPipelines)

            if (!selectedPipelineId || !fetchedPipelines.some((p) => p.id === selectedPipelineId)) {
                if (fetchedPipelines.length > 0) {
                    const selectpipe = fetchedPipelines.find((el) => el.is_active === "yes") || fetchedPipelines[0]
                    setSelectedPipelineId(selectpipe.id)
                }
            }
        } else if (pipelineData?.status === "fail") {
            setPipelines([])
            setSelectedPipelineId(null)
            if (pipelineData.message) {
                toast.error(pipelineData.message)
            }
        }
    }, [pipelineData])

    const pipelineStageUrl = selectedPipelineId ? `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}` : null

    // Fetch pipeline stages for selected pipeline
    const {
        data: pipelineStageData,
        isLoading: isPipelineStageLoading,
        refetch: refetchPipelineStage,
    } = useGetRequest(
        pipelineStageUrl,
        ["fetchPipelineStage", selectedPipelineId],
        headers,
        extras,
        {
            enabled: !!selectedPipelineId,
        }
    )

    useEffect(() => {
        const sharedUsers = leadsApiData?.pipeline_data?.["shared_to"]
        setParsedSharedUsers(JSON.parse(sharedUsers !== undefined && sharedUsers))

        setLeadsData(
            leadsApiData?.data?.map(stage => ({
                ...stage,
                leads: stage.leads?.map(lead => ({
                    ...lead,
                    product_services:
                        typeof lead.product_services === "string"
                            ? (() => {
                                try {
                                    return JSON.parse(lead.product_services)
                                } catch {
                                    return lead.product_services
                                }
                            })()
                            : lead.product_services
                }))
            }))
        );
    }, [leadsApiData])

    // // Handle pipeline stage data updates and formatting
    useEffect(() => {
        if (pipelineStageData?.status === "success") {
            const formattedStages = pipelineStageData.data.map((stage) => ({
                ...stage,
                stage_id: stage.id,
                sequence: String(stage.sequence),
                probability: Math.min(100, stage.probability || 0),
                rotting_days: stage.rotting_days === null ? null : stage.rotting_days,
                rotting_enabled: stage.rotting_days !== null && stage.rotting_days > 0,
            }))
            const filterDropdownData = pipelineStageData.data.map((c) => ({
                stage_id: c.id,
                stage_name: c.stage_name
            }))
            setPipelineStages(formattedStages)
            setSelectedStageId(formattedStages[0]?.id)
            setFilterDropPipelineStage(filterDropdownData)
        } else if (pipelineStageData?.status === "fail") {
            setPipelineStages([])
            if (pipelineStageData.message) {
                toast.error(pipelineStageData.message)
            }
        }
    }, [pipelineStageData])

    // useeffect for setting the first lead or deal module item it
    useEffect(() => {
        if (!myFollowUP) return
        // could be lead or deal module's, item id
        const id = myFollowUP[0]?.type?.toLowerCase() === "leads" ? myFollowUP[0]?.lead_id : myFollowUP[0]?.deal_id;
        setCurrId(id)
        setCurrModule(myFollowUP[0]?.type?.toLowerCase()?.slice(0, 4));
        setContactEmail(myFollowUP[0]?.email)
    }, [myFollowUP])

    // Close lead details and refresh data
    const handleCloseLeadDetails = () => {
        setCurrId(null);
        setRefetchLeadsData(true);
    };
    // Show delete confirmation modal for lead
    const handleDeleteLead = (leadId) => {
        setDeleteLeadId(leadId)
        setShowDeleteModal(true)
    }
    // Open edit lead form with specific lead ID
    const handleEditLead = (leadId) => {
        setEditLeadId(leadId)
        setSelectedStageId(null)
        setShowCreateLead(true)
    }

    // Refresh leads after update
    const handleLeadUpdated = () => {
        refetchLeads()
    }

    // Close create lead form and reset selection
    const handleCreateLeadClose = () => {
        setShowCreateLead(false)
        setSelectedStageId(null)
    }


    // ----------------------------- DEALS HANDLERS AND EFFECTS -----------------------

    const {
        data: dealsApiData,
        refetch: refetchDeals,
    } = useGetRequest(
        `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${customer.customer_details?.user_type}/list`
        , ["fetchAllDeals", selectedPipelineId,],
        headers,
        { customer, setCustomer, rf: headers.Authentication, navigate },
        { enabled: !!selectedPipelineId, }
    )
    // Close lead details and refresh data
    const handleCloseDealDetails = () => {
        setCurrId(null)
    }

    // ----------------------------- Followup fetching -----------------------
    const fetchMyfollowUp = async () => {
        try {
            const customer_id = customer?.customer_details?.customer_id;
            const headers = {
                Authorization: customer?.token?.authorization || "",
                Authentication: customer?.token?.authentication || "",
            };
            const extras = { customer, setCustomer, rf: customer?.token?.authentication, navigate };

            let filterValue = filter.trim().toLowerCase().split(" ").join("_");
            filterValue = filterValue === "all_followup" ? "all" :
                filterValue === "today_followup" ? "today" :
                    filterValue === "due_followup" ? "due" : 'custom';

            // if the limit is for 50 then i have to sent the half of it since followup includes both leads and deals which are being fetched seperately from respective tables.
            const res = await GetRequest(`taskboard/pendingFollowups/${customer_id}/${customer?.customer_details?.id}/${filterValue}/${customer.customer_details?.user_type}?from=${customFrom}&to=${customTo}&limit=${limit}&offset=${offset}&search=${searchInput}`, { headers }, extras);

            if (res.status === "fail" || res.success === false) {
                toast.error(res.message);
                setTotalFollowup(res?.total_count)
                setMyFollowUp([])
                return
            }
            setTotalFollowup(res?.total_count)
            setMyFollowUp(res.data || []);
        } catch (error) {
            return
        }
    };

    useEffect(() => {
        fetchMyfollowUp();
    }, [filter, customFrom, customTo, offset]);

    // just to ensure when user will make any search then whichever current page it is on that should be reset to 0
    useEffect(() => {
        if (searchInput?.trim()?.length !== 0) {
            setOffset(0)
        }
        fetchMyfollowUp()
    }, [searchInput])

    // Priority styling helper
    const getPriorityColor = (p) => {
        const colors = { high: '#ef4444', medium: '#f59e0b', low: '#10b981' };
        return colors[p?.toLowerCase()] || '#64748b';
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "medium":
                return "text-warning"
            case "low":
                return "text-primary"
            case "high":
                return "text-danger"
            default:
                return "bg-secondary"
        }
    }

    return (
        <Row
            className="Projectscard w-100 mx-0 g-0"
        >
            <Col md={5} className="ms-0 d-flex listStyleForContact flex-column gap-2 px-3 pb-3 pt-0 meetings-scroll-container " style={{ minHeight: "calc(100vh - 14rem)", maxHeight: "calc(100vh - 14rem)", overflowY: "auto", overflowX: "hidden", position: 'relative', borderRight: "1px solid rgb(224, 228, 248)" }}>
                <div
                    className="d-flex align-items-center justify-content-between position-sticky py-2 px-1"
                    style={{
                        top: "0rem",
                        zIndex: 100,
                        background: "white",
                    }}
                >
                    <p className="mb-0" style={{ fontSize: "14px" }}>
                        Showing {displayStartItem}-{displayEndItem} of {totalFollowup} items
                    </p>
                    <Dropdown
                        style={{ zIndex: 99, }}
                        show={openFilter}
                        ref={filterDropRef}
                    >
                        <Dropdown.Toggle
                            as="button"
                            onClick={() => setOpenFilter(prev => !prev)}
                            className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 text-muted no-arrow"
                            style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef' }}
                        >
                            <IconFilter size={16} color="#7a3a5e" />
                            {filter}
                            <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow" style={{ zIndex: 9999, marginTop: "3px" }} align={"end"}>
                            <Dropdown.Item
                                onClick={() => {
                                    setFilter(`All Followup`);
                                    setOffset(0);
                                    setShowCustomInputs(false);
                                    setOpenFilter(false);
                                }}
                            >
                                All FollowUp
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setFilter(`Today Followup`);
                                    setOffset(0);
                                    setShowCustomInputs(false);
                                    setOpenFilter(false);
                                }}
                            >
                                Today FollowUp
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setFilter(`Due Followup`);
                                    setOffset(0);
                                    setShowCustomInputs(false);
                                    setOpenFilter(false);
                                }}
                            >
                                Due FollowUp
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setShowCustomInputs(true);
                                }}
                            >
                                Custom FollowUp
                                {showCustomInputs && (
                                    <div className="d-flex gap-2 mt-2">
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={customFrom}
                                            onChange={(e) => setCustomFrom(e.target.value)}
                                            placeholder="From"
                                        />

                                        <input
                                            type="date"
                                            className="form-control"
                                            value={customTo}
                                            onChange={(e) => setCustomTo(e.target.value)}
                                            placeholder="To"
                                        />
                                        <button
                                            className="btn-sm btn-default"
                                            onClick={() => {
                                                setFilter(`Custom Followup`);
                                                setOffset(0);
                                            }}>
                                            Submit
                                        </button>
                                    </div>
                                )}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                {
                    myFollowUP?.length !== 0 ?
                        <>
                            {myFollowUP.map((item, index) => {
                                const cardColors = ["#2b0dff05", "#ff330005"]
                                const cardColor = cardColors[index % cardColors.length]

                                // New logic for setting followup date and time
                                const today = new Date()
                                const todayStr = today.toISOString().split("T")[0]

                                const overdue = item.followup_date && item.followup_date < todayStr
                                return <>
                                    <div
                                        key={item.id}
                                        className={`meeting-card  position-relative ${currId === (item.type?.trim()?.slice(0, 4) === "lead"
                                            ? item?.lead_id
                                            : item?.deal_id)
                                            ? "shadow-sm"
                                            : ""
                                            }`}
                                        style={{
                                            backgroundColor: cardColor,
                                            cursor: "pointer",
                                            border:
                                                currId === (item.type?.trim()?.slice(0, 4) === "lead"
                                                    ? item?.lead_id
                                                    : item?.deal_id)
                                                    ? cardColor === "#2b0dff05"
                                                        ? " 2px solid #c5beff80"
                                                        : "2px solid #ffc0b380"
                                                    : "1px solid #efefef",
                                            transition: "border 0.2s ease-in-out",
                                        }}
                                        onClick={() => {
                                            setCurrId(item.type?.trim()?.slice(0, 4) === "lead" ? item?.lead_id : item?.deal_id)
                                            setCurrModule(item.type?.toLowerCase()?.slice(0, 4))
                                        }}
                                    >
                                        <div className="meeting-info">
                                            <h4
                                                className="meeting-title"
                                                style={{ textTransform: "capitalize", fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
                                            >
                                                <span
                                                    className="contact-name fw-semibold cursor-pointer transition-all"
                                                    style={{ fontSize: '14px', textTransform: "capitalize", whiteSpace: "nowrap" }}
                                                >
                                                    {item?.contact_name}
                                                </span>
                                            </h4>
                                        </div>
                                        <div className="d-flex gap-3 align-items-center w-100">
                                            <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-full"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "50%",
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        color: "#2656a8",
                                                        marginTop: "4px",
                                                        border: "1px solid #d5e4ff",
                                                        marginRight: '8px'
                                                    }}
                                                >
                                                    <IconCalendarEvent size={14} className="" stroke={1.5} />
                                                </div>
                                                <div
                                                    className="d-flex flex-column align-items-start flex-fill"
                                                    style={{
                                                        paddingRight: '1rem',
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <span htmlFor="followup-due-date" className="d-flex align-items-center" style={{ fontSize: '12px', ...miniLabelStyle }}>Due Date</span>
                                                    <span id="followup-due-date text-truncate" style={{ fontSize: '0.833rem', color: `${overdue && "red"}`, fontWeight: 400 }}> {formatDate(item?.followup_date)}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-full"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "50%",
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        color: "#2656a8",
                                                        marginTop: "4px",
                                                        border: "1px solid #d5e4ff",
                                                        marginRight: '8px'
                                                    }}
                                                >
                                                    <IconBriefcase2 size={14} className="" stroke={1.5} />
                                                </div>
                                                <div
                                                    className="d-flex flex-column align-items-start flex-fill"
                                                    style={{
                                                        paddingRight: '1rem',
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <span htmlFor="followup-due-date" className="d-flex align-items-center" style={{ fontSize: "12px", ...miniLabelStyle }}>Type</span>
                                                    <span
                                                        id="followup-due-date text-truncate"
                                                        style={{
                                                            fontSize: '0.833rem',
                                                            textTransform: 'capitalize',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '100%',
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        {item?.type || '-'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                                                <div
                                                    className="d-flex align-items-center justify-content-center fullounded-2"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "50%",
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        marginTop: "4px",
                                                        border: "1px solid #d5e4ff",
                                                        color: "#2656a8",
                                                        marginRight: '8px'
                                                    }}
                                                >
                                                    <IconSitemap size={14} className="" stroke={1.5} />
                                                </div>
                                                <div
                                                    className="d-flex flex-column align-items-start flex-fill"
                                                    style={{ minWidth: 0 }}
                                                >
                                                    <span htmlFor="followup-due-date" className="d-flex align-items-center" style={{ fontSize: "12px", ...miniLabelStyle }}>Pipeline Name</span>
                                                    <span
                                                        id="followup-due-date text-truncate "
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '120px',
                                                            display: 'block',
                                                            fontSize: '0.833rem',
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        {item?.pipeline_name || '-'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            })}
                            <div
                                className=" d-flex justify-content-end align-items-center mt-2"
                            >
                                <FilterPagination
                                    offset={Math.floor(offset / limit)}
                                    setOffset={setOffset}
                                    handlePageChange={(selectedItem) => {
                                        setOffset(selectedItem.selected * limit)
                                    }}
                                    pageCount={pageCount}
                                    limit={limit}
                                />
                            </div>
                        </>
                        :
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ position: "absolute", left: "25%", top: "30%" }}
                        >
                            <img
                                src={nodata}
                                alt=""
                                style={{ width: "17rem", marginTop: "0" }}
                            />
                        </div>
                }

            </Col>

            {
                !currId &&
                <Col md={7} style={{ paddingLeft: '5px' }}>
                    <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted p-5 border rounded-3 bg-light-subtle" style={{ borderStyle: 'dashed !important' }}>
                        <IconChecklist size={48} stroke={1} className="mb-3 opacity-50" />
                        <p className="fw-medium">Select a Followup from the list to view details</p>
                    </div>
                </Col>
            }

            {
                (currId !== null && currModule === "lead") &&
                <FollowUpPage
                    id={currId}
                    module_name={'lead'}
                    followupGrant={leadFollowupGrant}
                />
            }
            {
                (currId !== null && currModule === "deal") &&
                <FollowUpPage
                    id={currId}
                    module_name={'deal'}
                    followupGrant={dealFollowupGrant}
                />
            }



        </Row >
    );
};

const miniLabelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
}; 